import SettingsModule from 'automation-ui-canvas/containers/settings/v2/SettingsModule';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import ListSegmentationFilters from 'automation-ui-enrollment/components/common/ListSegmentationFilters';
import { useHasScope } from 'automation-ui-core/hooks/authHooks';
import { WORKFLOWS_EDIT_TEAM_OWNED } from 'automation-ui-canvas/constants/Scopes';
import { StyledCriteraBorder } from 'automation-ui-enrollment/components/eventEnrollment/steps/EventEnrollmentReview';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const UnenrollmentTriggerSettingV2 = ({
  flow,
  readOnly,
  settings: {
    suppressionFilters
  },
  onChange
}) => {
  const hasEditEnrollmentAccess = useHasScope(WORKFLOWS_EDIT_TEAM_OWNED);
  return /*#__PURE__*/_jsx(SettingsModule, {
    header: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "settingsV2.unenrollmentTriggerSettingV2.title_cob",
      objectTypeId: flow.objectTypeId
    }),
    body: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(ListSegmentationFilters, {
        WrapperComponent: StyledCriteraBorder,
        headerNode: null,
        value: suppressionFilters === null || suppressionFilters === void 0 ? void 0 : suppressionFilters.value,
        objectTypeId: flow.objectTypeId,
        readOnly: !hasEditEnrollmentAccess || !!readOnly,
        onChange: newFilters => {
          onChange({
            suppressionFilters: {
              value: newFilters
            }
          });
        },
        openInEditMode: false
      })
    })
  });
};
export default UnenrollmentTriggerSettingV2;